// extracted by mini-css-extract-plugin
export default {"boxInfoMsg":"IS-z","boxErrorMsg":"JS-z","blockMsg":"KS-z","blockInfoMsg":"LS-z","blockErrorMsg":"MS-z"};